<template>
<div v-if="empleado">
    <Box @close="cerrar(false)">
        <template #top>Modificar Empleado</template>
        <template #center>
            <div class="nj-cols">
                <div class="nj-card">
                    <div class="nj-cols form c3">
                        <div>
                            <div class="nj-label">Nombre</div>
                            <input type="text" class="nj-text" v-model="empleado.emp_nombre" ref="emp_nombre">
                        </div>
                        <div>
                            <div class="nj-label">Apellido</div>
                            <input type="text" class="nj-text" v-model="empleado.emp_apellido">
                        </div>
                        <div>
                            <div class="nj-label">DNI</div>
                            <input type="text" class="nj-text" v-model="empleado.emp_dni">
                        </div>
                        <div>
                            <div class="nj-label">Celular</div>
                            <input type="text" class="nj-text" v-model="empleado.emp_celular">
                        </div>
                        <div>
                            <div class="nj-label">Correo electrónico</div>
                            <input type="text" class="nj-text" v-model="empleado.emp_email">
                        </div>
                        <div>
                            <div class="nj-label">Proyecto</div>
                            <select class="nj-select" v-model="empleado.pry_id">
                                <option></option>
                                <option v-for="item in proyectos" :key="item.pry_id" :value="item.pry_id">{{ item.pry_nombre }}</option>
                            </select>
                        </div>
                        <div>
                            <div class="nj-label">Puesto</div>
                            <select class="nj-select" v-model="empleado.pue_id">
                                <option></option>
                                <option v-for="item in puestos" :key="item.pue_id" :value="item.pue_id">{{ item.pue_nombre }}</option>
                            </select>
                        </div>
                        <div style="align-self: flex-end;">
                            <div class="nj-label">&nbsp;</div>
                            <div class="nj-check">
                                <input type="checkbox" id="isUsuario" v-model="empleado.genera_usuario" @change="reiniciar()">
                                <label for="isUsuario">Crear cuenta de usuario</label>
                            </div>
                        </div>
                    </div>
                </div>
                <template v-if="empleado.genera_usuario">
                    <div class="nj-card">
                        <h1 class="subtitle">Datos de usuario</h1>
                        <div class="nj-cols form c3">
                            <div>
                                <div class="nj-label">Tipo</div>
                                <select class="nj-select" v-model="empleado.usuario.tiu_id">
                                    <option v-for="item in tipos_usaurio" :key="item.tiu_id" :value="item.tiu_id">{{ item.tiu_nombre }}</option>
                                </select>
                            </div>
                            <div>
                                <div class="nj-label">Usuario</div>
                                <input type="text" class="nj-text" v-model="empleado.usuario.usu_correo" ref="emp_nombre">
                            </div>
                            <div>
                                <div class="nj-label">Password</div>
                                <input type="password" class="nj-text" v-model="empleado.usuario.usu_password">
                            </div>
                            <div>
                                <div class="nj-label">Nivel</div>
                                <select class="nj-select" v-model="empleado.usuario.usu_nivel">
                                    <option v-for="item in lista_usuario_nivel" :key="item.niu_id" :value="item.niu_id">{{ item.niu_nombre }}</option>
                                </select>
                            </div>
                            <div>
                                <div class="nj-label">Roles</div>
                                <select class="nj-select" multiple v-model="id_roles">
                                    <option v-for="item in roles" :key="item.rol_id" :value="item.rol_id">{{ item.rol_nombre }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </template>
        <template #bottom>
            <button class="nj-button c-green" @click="modificar()"><i class="mdi mdi-content-save"></i>Modificar</button>
        </template>
    </Box>
</div>
</template>
<script>
import TipoUsuario from "../../constants/tipoUsuario"
import { AppService, EmpleadoService, ResponseStatus, ProyectoService } from "../../rest"
import PuestoService from "../../services/PuestoService"
import RolService from "../../services/RolService"
import Toast from "../../util/toast"
import { Box } from "../components"

export default {
    name: "EmpleadoEdit",
    components: {
        Box
    },
    props: {
        emp_id: {
            type: Number
        }
    },
    data() {
        return {
            empleado: null,
            roles: [],
            puestos: [],
            lista_usuario_nivel: [],
            id_roles: [],
            proyectos: [],
            tipos_usaurio: [],
        }
    },
    methods: {
        obtener() {
            EmpleadoService.obtener(this.emp_id).then(
                response => {
                    this.empleado = response.data
                    this.empleado.usuario = {
                        usu_correo: null,
                        usu_password: null,
                        usu_nivel: null,
                        tiu_id: null,
                        lista_usuario_rol: []
                    }
                    this.empleado.usuario.usu_nivel = 0
                    this.empleado.usuario.tiu_id = 1
                    this.empleado.usuario.usu_correo = this.empleado.emp_email
                },
                error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                }
            )
        },
        modificar() {
            let errors = 0
            if (this.empleado.emp_nombre == null) errors++
            if (this.empleado.emp_apellido == null) errors++
            if (this.empleado.emp_email == null) errors++
            if (this.empleado.pue_id == null) errors++
            if (this.empleado.pry_id == null) errors++
            if (this.empleado.genera_usuario) {
                if (this.empleado.usuario.usu_correo == null) errors++
                if (this.empleado.usuario.usu_password == null) errors++
                if (this.id_roles.length == 0) errors++
            }
            if (errors == 0) {
                if (this.empleado.genera_usuario) {
                    this.id_roles.forEach(item => {
                        this.empleado.usuario.lista_usuario_rol.push({
                            rol_id: item
                        })
                    })
                }
                EmpleadoService.modificar(this.empleado).then(
                    response => {
                        Toast.success(response.message)
                        this.cerrar(true)
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    }
                )
            } else {
                Toast.warn("Faltan ingresar datos")
            }
        },
        cerrar(condition) {
            this.$emit("close", condition)
        },
        reiniciar() {
            if (!this.empleado.genera_usuario) {
                this.empleado.usu_correo = null
                this.empleado.usu_password = null
                this.empleado.usuario.lista_usuario_rol = []
                this.id_roles = []
            }
        },
    },
    mounted() {
        // Cargando niveles
        AppService.getData(["niveles_usuario"]).then(
            response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.lista_usuario_nivel = response.data.niveles_usuario
                    // Cargando los puestos
                    PuestoService.buscar({
                        pue_estado: 1
                    }).then(
                        response => {
                            this.puestos = response.data
                            // Cargando roles
                            RolService.buscar().then(
                                response => {
                                    this.roles = response.data
                                    // Cargando proyectos (activos)
                                    ProyectoService.buscar({
                                        pry_estado: 1
                                    }).then(
                                        response => {
                                            this.proyectos = response.data
                                            // Cargando tipos de usuarios
                                            this.tipos_usaurio.push(TipoUsuario.data.EMPLEADO)
                                            this.obtener()
                                        },
                                        error => {
                                            Toast.error(error)
                                            console.error(`error: `, error)
                                        }
                                    )
                                },
                                error => {
                                    Toast.error(error)
                                    console.error(`error: `, error)
                                }
                            )
                        },
                        error => {
                            Toast.error(error)
                            console.error(`error: `, error)
                        }
                    )
                }
                else {
                    Toast.warn(response.message)
                }
            },
            error => {
                Toast.error(error)
                console.error(`error: `, error)
            }
        )
    }
}
</script>

<style scoped></style>